<script lang="ts">
  import { createContext } from 'reka-ui'

  const [_useContentToggle, provideContentToggle] = createContext<{
    provided: boolean
    open: Ref<boolean>
  }>('gs-content-toggle')

  export function useContentToggle() {
    try {
      return _useContentToggle()
    } catch (error) {
      return {
        provided: false,
        open: ref(false)
      }
    }
  }
</script>

<script setup lang="ts">
  import { type HTMLAttributes, type Ref, ref } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  defineOptions({
    inheritAttrs: false
  })

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
    }>(),
    {}
  )

  const open = defineModel<boolean>('open', {
    default: false
  })

  provideContentToggle({
    provided: true,
    open
  })
</script>

<template>
  <div :class="cn('group flex flex-col gap-2', props.class)" :data-open="open">
    <slot
      v-if="!open"
      name="trigger"
      :props="{ onClick: () => (open = !open) }"
    />
    <div
      class="group-data-[open=true]:flex group-data-[open=false]:hidden group-data-[open=true]:flex-col group-data-[open=true]:gap-2"
    >
      <slot></slot>
    </div>
  </div>
</template>
